import styled from 'styled-components';

export const TitleLogo = styled.img`
    margin-right: 8px;
    margin-bottom: -1px;
`;
